module.exports = __webpack_public_path__ + "img/oktoberfest_2.461d71fd.jpg";